// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__rQxWp","loader":"Loader_loader__7ZWW3","l1":"Loader_l1__jAmgy","loadingText":"Loader_loadingText__hP_dV"};